export const CLAIM_SIDES = ['sales', 'purchasing'] as const;
export type ClaimSide = (typeof CLAIM_SIDES)[number];

export const CLAIM_TYPES = ['shortage', 'damage', 'quality', 'price', 'other'] as const;
export type ClaimType = (typeof CLAIM_TYPES)[number];

export const CLAIM_STATUSES = [
  'draft',
  'submitted',
  'under_review',
  'approved',
  'rejected',
  'resolved',
] as const;
export type ClaimStatus = (typeof CLAIM_STATUSES)[number];

export const CLAIM_REMEDIES = ['credit', 'replacement', 'refund', 'rework'] as const;
export type ClaimRemedy = (typeof CLAIM_REMEDIES)[number];

export type ClaimOrderType = 'sales_order' | 'purchase_order';

export interface ClaimOrderReference {
  orderType: ClaimOrderType;
  orderId: string;
  orderNumber: string;
  lineId: string;
  productId: string;
  productName: string;
}

export interface ClaimAuditEntry {
  id: string;
  fromStatus: ClaimStatus | null;
  toStatus: ClaimStatus;
  actor: string;
  reason: string;
  remedy?: ClaimRemedy;
  at: string;
}

export interface Claim {
  id: string;
  claimNumber: string;
  side: ClaimSide;
  type: ClaimType;
  status: ClaimStatus;
  reference: ClaimOrderReference;
  quantity?: number;
  amount?: number;
  currency: string;
  evidenceNote: string;
  owner: string;
  remedy?: ClaimRemedy;
  decisionReason?: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  auditHistory: ClaimAuditEntry[];
}

export interface ClaimListParams {
  page?: number;
  pageSize?: number;
  search?: string;
  side?: ClaimSide;
  status?: ClaimStatus;
}

export interface ClaimListResponse {
  data: Claim[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
}

export interface CreateClaimRequest {
  side: ClaimSide;
  type: ClaimType;
  reference: ClaimOrderReference;
  quantity?: number;
  amount?: number;
  currency?: string;
  evidenceNote: string;
  owner: string;
  actor: string;
}

export interface TransitionClaimRequest {
  status: ClaimStatus;
  decisionReason: string;
  remedy?: ClaimRemedy;
  actor: string;
}

export const CLAIM_STATUS_TRANSITIONS: Readonly<Record<ClaimStatus, readonly ClaimStatus[]>> = {
  draft: ['submitted'],
  submitted: ['under_review'],
  under_review: ['approved', 'rejected'],
  approved: ['resolved'],
  rejected: ['resolved'],
  resolved: [],
};
